import { notificationState } from './notification.state';
import { notificationActions } from './notification.actions';
import { notificationMutations } from './notification.mutations';
import { notificationGetters } from './notification.getters';
import { Module } from 'vuex';
import { RootState } from '@/store/store';
import { NotificationState } from './types/notification.types';

export default {
  namespaced: true,
  state: notificationState,
  getters: notificationGetters,
  actions: notificationActions,
  mutations: notificationMutations,
} as Module<NotificationState, RootState>;
